<template>
  <div class="w-100">
    <form ref="form" v-kendo-validator novalidate>
      <div class="page-header d-flex w-100">
        <div class="title-col d-flex w-50">
          <span class="title-icon">
            <span class="nt-plus-square-fill"></span>
          </span>
          <span class="title-text">Configure SAAS</span>
        </div>
        <div class="text-right ml-auto">
          <button class="k-button k-primary ml-2" type="button" @click="save" v-if="!readOnly">Save</button>
        </div>
      </div>
      <div class="page-body">
        <div class="row">
          <div class="col-sm-4" v-for="(config,index) in tenantSaaS" :key="index">
            <div class="form-group">
              <label>{{config.key}}</label>
              <k-input
                :name="config.key"
                class="w-100"
                :required="true"
                v-model="config.value"
                :disabled="readOnly"
              />
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapMultiRowFields } from "vuex-map-fields";
import { createNamespacedHelpers } from "vuex";
import { notifyApiError, notify } from "../../utils/notification-helper";
const { mapActions } = createNamespacedHelpers("onboarding");
export default {
  props: ["readOnly"],
  computed: {
    ...mapMultiRowFields(["onboarding.tenantSaaS"])
  },
  methods: {
    ...mapActions(["saveSaasConfig"]),
    save: function() {
      this.saveSaasConfig()
        .then(message => {
          notify(message);
          this.canContinue();
        })
        .catch(notifyApiError);
    },
    canContinue() {
      this.$emit("can-continue", { value: true });
    }
  }
};
</script>

<style>
</style>